import dayjs from 'dayjs'
import { formatDate } from '@utils'
import { FilterCondition, RelativeDatetimeValue } from '../nodes/types'
import { isRelativeDatetimeValue } from '../nodes/filterConfigUtils'

const DAYJS_UNIT: Record<string, dayjs.ManipulateType> = {
  minutes: 'minute',
  hours: 'hour',
  days: 'day'
}

export const formatRelativeCutoff = (amount: number, unit: string): string => {
  const cutoff = dayjs().subtract(amount, DAYJS_UNIT[unit] ?? 'day')
  return `${formatDate(cutoff)} ${cutoff.format('HH:mm')}`
}

export const getAbsoluteDatetimeValue = (value: FilterCondition['value']): string =>
  typeof value === 'string' ? value : ''

export const getRelativeDatetimeValue = (value: FilterCondition['value']): RelativeDatetimeValue =>
  isRelativeDatetimeValue(value) ? value : { kind: 'relative', amount: 7, unit: 'days' }

export const isValidRelativeAmount = (value: string): boolean => {
  if (!value.trim()) return false
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed >= 1 && Number.isInteger(parsed)
}
